import http from "@/http-common";

class ProductService {
  getAllLikedProducts() {
    return http.get("/product/likes", {
      params: {
        limit: 200,
        offset: 0,
      },
    });
  }

  likeProduct(id) {
    return http.put(`/product/${id}/like`);
  }

  unlikeProduct(id) {
    return http.delete(`/product/${id}/like`);
  }

  loadProduct(id) {
    return http.get(`/product/${id}`).then(
      (response) => {
        const product = response.data;
        return Promise.resolve(product);
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  }

  hideProduct(id) {
    return http.put(`/product/${id}/hide`);
  }

  getFeed(params) {
    return http.get("/product/feed", { params });
  }

  getNew(params) {
    return http.get("/product/new", { params });
  }

  getTrending(params) {
    return http.get("/product/trending", { params });
  }

  getDiscover(params) {
    return http.get("/product/discover", { params });
  }
}

export default new ProductService();
